import FiltrarPrestamos from '../../../components/ui/Admin/FiltrarPrestamosComponents/FiltrarPrestamos';

const FiltrarPrestamosUI = () => {
  return (
    <div className="pb-4">
        <FiltrarPrestamos />
    </div>
  );
};

export default FiltrarPrestamosUI;
